import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import styled from 'styled-components';
import { FormLabel, FormControl, FormControlLabel, Checkbox as MuiCheckbox } from '@material-ui/core';
var StyledLabel = styled.div.withConfig({
  displayName: "Checkbox__StyledLabel",
  componentId: "ek5vdd-0"
})(["display:flex;align-items:flex-end;"]);

var Checkbox = function Checkbox(_ref) {
  var disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      e2e = _ref.e2e,
      required = _ref.required,
      indeterminate = _ref.indeterminate,
      label = _ref.label,
      checked = _ref.checked,
      name = _ref.name,
      value = _ref.value;
  var checkbox =
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(MuiCheckbox, _extends({
    disabled: disabled
  }, e2e && {
    'data-e2e': e2e
  }, {
    indeterminate: indeterminate,
    required: required,
    checked: !!checked,
    name: name,
    onChange: dsOnChange,
    value: value,
    color: "primary"
  }, e2e && {
    inputProps: {
      'data-e2e': "".concat(e2e, "-input")
    }
  }));

  if (label) {
    return /*#__PURE__*/React.createElement(FormControl, {
      required: required
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      disabled: disabled,
      label: /*#__PURE__*/React.createElement(StyledLabel, null, label, /*#__PURE__*/React.createElement(FormLabel, null)),
      control: checkbox
    }));
  }

  return checkbox;
};

export default Checkbox;

try {
  Checkbox.__docgenInfo = {
    description: '',
    displayName: 'Checkbox',
    methods: [],
    props: {
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: true,
        type: {
          name: '(event: ChangeEvent<HTMLInputElement>, checked: boolean) => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'If `true`, the checkbox will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      name: {
        defaultValue: null,
        description: 'Name attribute of the `input` element.',
        name: 'name',
        required: false,
        type: {
          name: 'string'
        }
      },
      value: {
        defaultValue: null,
        description: 'The value of the component. The DOM API casts this to a string.\n' + 'The browser uses "on" as the default value.',
        name: 'value',
        required: false,
        type: {
          name: 'unknown'
        }
      },
      checked: {
        defaultValue: null,
        description: 'If `true`, the component is checked.',
        name: 'checked',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the `input` element will be required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      indeterminate: {
        defaultValue: null,
        description: 'If `true`, the component appears indeterminate.\n' + 'This does not set the native input element to indeterminate due\n' + 'to inconsistent behavior across browsers.\n' + 'However, we set a `data-indeterminate` attribute on the input.',
        name: 'indeterminate',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map